<template>
  <section class="d-flex flex-column h-full">
    <!-- <div class="fixed-header w-full"> -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    ></TopAppBar>

    <div class="flex-grow-1 scroll-y">
      <PointEarnList></PointEarnList>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import PointEarnList from "@/components/point/PointListEarn";

export default {
  name: "PointEarn",

  data() {
    return {
      // title
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
    };
  },
  components: {
    TopAppBar,
    PointEarnList,
  },

  mixins: [topAppBarMixin],

  watch: {
    $route(to, from) {
    },
  },

  mounted() {
    this.leftBtnMode = "arrow_back";
    this.rightBtnMode = "";
    this.title = this.$t("1893");
    this.leftBtnMethod = () => {
      this.$router.push("/point");
    };
    this.rightBtnMethod = "";
  },
};
</script>
